<template>
  <div class="consent-education-3 common-consent-edu">
    <div class="text-center verify-name pb-24" v-translate:pweb_title_docu_and_sign="lang">
      Document and Signature
    </div>
    <div v-if="consentObj && consentObj.config && consentObj.config.consentId && !!getParticipantStudyVideos" v-quill-html:getParticipantStudyVideos.src="consentObj.config.consentId" class="dynamicConsentContent"></div>
    <div v-else-if="consentObj && consentObj.config && consentObj.config.consentId && !!documentAndSignHtml" v-html="documentAndSignHtml" class="dynamicConsentContent"></div>
    <div class="form-check checkbox-new path" v-for="(disclamer, index) in getConsentEduction" :key="index">
      <input :class="{ 'required-input': disclamer.required }" type="checkbox" @change="onDisclamerChange(disclamer)" v-model="disclamer.value" class="form-check-input CohertConsentCheckbox" />
      <svg viewBox="0 0 21 21">
        <path d="M5,10.75 L8.5,14.25 L19.4,2.3 C18.8333333,1.43333333 18.0333333,1 17,1 L4,1 C2.35,1 1,2.35 1,4 L1,17 C1,18.65 2.35,20 4,20 L17,20 C18.65,20 20,18.65 20,17 L20,7.99769186"></path>
      </svg>
      <label
        class="form-check-label"
        :for="'exampleCheck' + index"
        v-translate:dynamic_string="{
          key: `${disclamer.disclaimerId}_disclaimer`,
          val: lang,
          html: disclamer.disclaimer
        }"
        v-html="disclamer.disclaimer"
      ></label>
      <span class="desclaimer-asterics-label">
        <i v-if="disclamer.required" class="fa fa-asterisk asterickStyle fs-7 desclaimer-asterics" aria-hidden="true"></i>
      </span>
    </div>
    <div class="row pt-30 agree-btn-group">
      <div class="col-6 col-md-6 pl-0">
        <button
          v-if="consentObj.config.dataVantConsent"
          data-dismiss="modal"
          class="btn leavestudy"
          data-toggle="modal"
          data-target="#decline-cancel-modal"
          v-translate:decline="lang"
        >
          Decline
        </button>
        <button
          v-else
          data-dismiss="modal"
          class="btn leavestudy"
          data-toggle="modal"
          data-target="#disagreeModal1"
          v-translate:rsb_disagree="lang"
        >
          Disagree
        </button>
      </div>
      <div class="col-6 col-md-6 pr-0 discard-btn">
        <button data-dismiss="modal" class="btn leave_study_cntue primary-bg" data-toggle="modal" :disabled="isDisclamerSelected" data-target="#agreeModal1" v-translate:rsb_agree="lang">
          Agree
        </button>
      </div>
    </div>
    <div class="modal fade" id="disagreeModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="verification text-center">
              <label class="verify-name p-0 m-0" v-translate:rsb_consent_review_alert_title="lang">Review</label>
              <p class="edu-consent-text" v-translate:eula_disagree="lang">
                You must agree to the Terms of Use agreement to be able to participate in this study.
              </p>
            </div>
            <div class="row pt-30 agree-btn-group">
              <div class="col-6 col-md-6 pl-0">
                <button data-dismiss="modal" class="btn leavestudy" v-translate:rsb_consent_review_cancel="lang">
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6 pr-0 discard-btn">
                <button class="btn leave_study_cntue primary-bg" data-dismiss="modal" @click="notAgree" v-translate:rsb_disagree="lang">
                  Disagree
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="agreeModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding">
            <div class="verification text-center">
              <label
                class="verify-name p-0 m-0"
                v-translate:rsb_consent_review_alert_title="lang"
                >Review</label
              >
              <p
                v-if="consentObj.config.dataVantConsent"
                class="edu-consent-text"
                v-translate:rsb_datavant_review_reason="lang"
              >
                By providing your name and signature, you confirm that you 
                have read the information contained herein and would like to 
                proceed with tokenization/de-identification of your data.
              </p>
              <p
                v-else
                class="edu-consent-text"
                v-translate:rsb_consent_review_reason="lang"
              >
                By agreeing, you confirm you have read the information contained
                herein and wish to move forward in this process in order to take
                part in the study.
              </p>
            </div>
            <div class="row pt-30 agree-btn-group">
              <div class="col-6 col-md-6 pl-0">
                <button
                  v-if="consentObj.config.dataVantConsent"
                  data-dismiss="modal"
                  class="btn leavestudy"
                  data-toggle="modal"
                  data-target="#decline-cancel-modal"
                  v-translate:decline="lang"
                >
                  Decline
                </button>
                <button
                  v-else
                  data-dismiss="modal"
                  class="btn leavestudy"
                  v-translate:rsb_consent_review_cancel="lang"
                >
                  Cancel
                </button>
              </div>
              <div class="col-6 col-md-6 pr-0 discard-btn">
                <button class="btn leave_study_cntue primary-bg" data-dismiss="modal" @click="agreed" v-translate:rsb_agree="lang">
                  Agree
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div
      ref="declineCancelModel"
      class="modal fade"
      id="decline-cancel-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg m-10" role="document">
        <div class="modal-content">
          <div class="modal-body modal-padding p-28">
          <div class="verification text-center">
              <h2 class="p-0 m-0" v-translate:ml_are_you_sure="lang">Are you sure?</h2>
            </div>
            <div class="d-flex justify-content-end pt-50 ml-30 mr-30">
              <div class="col-6 col-md-6 pl-0">
                <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">Cancel</button>
              </div>
              <div class="col-6 col-md-6 pr-0 discard-btn">
                <button class="btn leave_study_cntue" data-dismiss="modal" @click="declineDatavantConsent" v-translate:rsb_discard_results="lang">Discard Results</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import { Consent, Widget, ParticipantPortal } from "@/components/services/participant-service";
import { v4 as uuidv4 } from "uuid";
export default {
  name: "join-disclaimer",
  components: {},
  props: ["isOnBackClick", "lang", "currentConsent"],
  data() {
    return {
      widget: new Widget(),
      consent: new Consent(),
      portal: new ParticipantPortal(),
      isParticipantAgreed: false,
      consentDisclaimer: [],
      documentAndSignHtml: ""
    };
  },
  watch: {
    isOnBackClick(val) {
      if (val) {
        if (this.currentConsent.config.educationEnabled) {
          this.$emit("backButtonClick", "questions");
        } else {
          this.$emit("updateConsentScreen", "prev-consent");
        }
      }
    }
  },
  computed: {
    ...mapGetters(["participant", "getParticipantStudyVideos"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    getConsentEduction() {
      return this.consent.getConcentDisclaimers();
    },
    consentObj() {
      return this.consent.currentConsentObj;
    },
    getConsentID() {
      return this.consentObj && this.consentObj.config.consentId;
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    getSiteID() {
      return this.study && this.study.sitesInfo[0] && this.study.sitesInfo[0].id;
    },
    isDisclamerRequired() {
      const requiredDisclamer = [];
      this.getConsentEduction.filter(disclamer => {
        if (disclamer.required) {
          requiredDisclamer.push(disclamer);
        }
      });
      return requiredDisclamer;
    },
    isDisclamerSelected() {
      if (this.isDisclamerRequired && this.isDisclamerRequired.length) {
        const totalUselected = [];
        this.isDisclamerRequired.filter(obj => {
          if (obj.required && !obj.value) {
            totalUselected.push(obj);
          }
        });
        if (totalUselected.length > 0) {
          return true;
        } else {
          return false;
        }
      }
      return false;
    }
  },

  mounted() {
    let i18KeyForConsentName = this.consent.currentConsentObj.config.dataVantConsent ? "datavant_consent_form_title" : `${this.consent.currentConsentObj.config.consentId}_consentName` ;
    let consentName = this.widget.i18nActivities(i18KeyForConsentName, this.lang);
    this.$emit("updateHeaderNav", {
      showBlankHeader: true,
      title: consentName || this.consent.currentConsentObj.config.consentName
    });
    this.getAgreementData();
  },
  methods: {
    getAgreementData() {
      nprogress.start();
      let agreementKey = this.consentObj.config.dataVantConsent ? 'datavant_consent' : this.consentObj.config.consentId;
      if (
        this.consent.bitrise.isAggrementAvailable(
          agreementKey
        )
      )
        this.consent
          .getDocumentAndSignHtml(agreementKey)
          .then((html) => {
            nprogress.done();
            this.documentAndSignHtml = html.body.innerHTML;
          })
          .catch(() => {
            nprogress.done();
          });
    },
    onDisclamerChange(disclamer) {
      const nowDate = new Date();
      const offset = new Date().getTimezoneOffset();

      const o = Math.abs(offset);
      const localTimeOffset = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
      const isoDateString = nowDate.toISOString();
      const consentData = {
        consentId: this.getConsentID,
        deviceId: uuidv4(),
        disclaimerCheckedOnLocal: isoDateString.replace("Z", localTimeOffset),
        disclaimerCheckedOnOffset: localTimeOffset,
        disclaimerCheckedOnUtc: isoDateString.replace("T", " ").slice(0, isoDateString.lastIndexOf(".")),
        disclaimerContent: disclamer.disclaimer,
        disclaimerId: disclamer.disclaimerId,
        displayDisclaimerContent: disclamer.disclaimer,
        displayLanguage: "EN",
        isDisclaimerRequired: disclamer.required,
        languageId: this.portal.getLanguage(),
        participantId: this.participantDetails && this.participantDetails.getParticipantID(),
        siteId: this.getSiteID,
        studyId: this.portal.getStudy()
      };
      this.consentDisclaimer.push(consentData);
    },
    agreed() {
      this.$emit("onConsentDisclaimer", this.consentDisclaimer);
      if (this.currentConsent && this.currentConsent.details.digitalSignatureEnabled) {
        this.$emit("updateConsentScreen", "signature");
      } else {
        this.$emit("updateConsentScreen", "isConcentSignCompleted");
      }
    },
    notAgree() {
      this.$root.$emit("resetToCohort");
    },
    declineDatavantConsent(){
      let consentSign = {
        consentId: this.consentObj.config.consentId,
        consentName: this.consentObj.config.consentName,
        firstName: "",
        lastName: "",
        signature: "",
        dataVantConsent: this.consentObj.config.dataVantConsent ? true : false
      };
      this.$emit("onConsentDisclaimer", []);
      this.$emit("onDeclineConsent", consentSign);
      this.$emit("updateConsentScreen", "isConcentSignCompleted");
    }
  },
};
</script>
<style scoped>
.checkbox-new {
  --background: #fff;
  --border: #979797;
  --border-hover: #3b3b3b;
  --border-active: #48bf94;
  --tick: #48bf94;
  --required: #fb1b1b;
  position: relative;
}
.checkbox-new input,
.checkbox-new svg {
  width: 16px;
  height: 16px;
}
.checkbox-new input {
  position: relative;
  outline: none;
  background: var(--background);
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 4px;
  transition: box-shadow 0.3s;
  box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--border));
  top: 3px;
}
.checkbox-new input:hover {
  --s: 1px;
  --b: var(--border-hover);
}
.checkbox-new input:checked {
  --b: var(--border-active);
}
.checkbox-new svg {
  pointer-events: none;
  fill: none;
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke: var(--stroke, var(--border-active));
  position: absolute;
  top: 9px;
  left: 1px;
  width: 16px;
  height: 16px;
  transform: scale(var(--scale, 1)) translateZ(0);
}
.checkbox-new.path input:checked {
  --s: 2px;
  transition-delay: 0.4s;
}
.checkbox-new.path input:checked + svg {
  --a: 16.1 86.12;
  --o: 102.22;
}
.checkbox-new.path svg {
  stroke-dasharray: var(--a, 86.12);
  stroke-dashoffset: var(--o, 86.12);
  transition: stroke-dasharray 0.6s, stroke-dashoffset 0.6s;
}
.checkbox-new.bounce {
  --stroke: var(--tick);
}
.checkbox-new.bounce input:checked {
  --s: 11px;
}
.checkbox-new.bounce input:checked + svg {
  animation: bounce 0.4s linear forwards 0.2s;
}
.checkbox-new.bounce svg {
  --scale: 0;
}
.checkbox-new .form-check-label {
  position: relative;
  top: 5px;
  left: 2px;
}
@keyframes bounce {
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
.desclaimer-asterics-label {
  position: absolute;
}
.desclaimer-asterics {
  position: absolute;
  top: 4px;
  right: -10px;
}
.checkbox-new .form-check-input.required-input {
  -webkit-box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--required));
  box-shadow: inset 0 0 0 var(--s, 1px) var(--b, var(--required));
}
.CohertConsentCheckbox {
  position: absolute !important;
}
.dynamicConsentContent {
  overflow: auto;
}
.consent-education-3 {
  width: 590px !important;
}
</style>
